import { render, staticRenderFns } from "./ButtonGroupView.vue?vue&type=template&id=3bca7627&scoped=true&"
import script from "./ButtonGroupView.vue?vue&type=script&lang=js&"
export * from "./ButtonGroupView.vue?vue&type=script&lang=js&"
import style0 from "./ButtonGroupView.vue?vue&type=style&index=0&id=3bca7627&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bca7627",
  null
  
)

export default component.exports